import VerificationType from "../models/VerificationType";
export const VerificationTypeMixin = {
  data() {
    return {
      verification_type: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new VerificationType({
        country_id: null,
        communication_type: 'sms',
        kyc_method: 'manual',
        instructions: '',
        dialog_content: '',
        on_review_email_content: '',
      })
    }
  }
}
